import checkoutSelectors from 'features/checkout/duck/selectors'
import { RootState } from 'redux/types'

import { ApplePayPostProceedBody } from './types'

interface PrepareApplePayArgs {
  state: RootState
}

export function prepareApplePay({ state }: PrepareApplePayArgs): ApplePayPostProceedBody {
  return { adyenApplePayToken: checkoutSelectors.getApplePayAuthToken(state) }
}
